import { EmptyState } from '@monorepo/shared/componentsV2/EmptyState';
import { FullScreenLoadingPage } from '@monorepo/shared/componentsV2/Loading';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { FormTemplateEditor } from '../FormTemplateEditor/FormTemplateEditor';
import { useFormTemplateContext } from './FormTemplateContext';
import { useFormTemplateUpdate } from './hooks/useFormTemplateUpdate';

type EditFormTemplatePageProps = {
  formWizardBasePath: string;
};

function useSubmitFormTemplate(organizationId: string) {
  const { formTemplate, resetDirtyState } = useFormTemplateContext();

  const [saveFormTemplate, { isLoading: isSubmitting }] = useFormTemplateUpdate(
    { resetDirtyState },
  );
  const onSubmit = useCallback(async () => {
    await saveFormTemplate({ formTemplate, organizationId });
  }, [formTemplate, organizationId, saveFormTemplate]);

  return { isSubmitting, onSubmit };
}

// todo@formTemplates LLENA: rename to EditFormTemplateFieldsPage
export function EditFormTemplatePage({
  formWizardBasePath,
}: EditFormTemplatePageProps) {
  useDisableSubnav();
  const { organizationId } = useParams();

  if (!organizationId) {
    throw new Error(
      "EditFormTemplatePage was rendered with a url that doesn't have organizationId",
    );
  }

  const { isLoading, isError } = useFormTemplateContext();

  const { isSubmitting, onSubmit } = useSubmitFormTemplate(organizationId);

  if (isLoading) return <FullScreenLoadingPage />;

  return isError ? (
    <EmptyState primaryText="There was a problem loading the form." />
  ) : (
    <FormTemplateEditor
      organizationId={organizationId}
      formWizardBasePath={formWizardBasePath}
      isEditMode
      isSubmitting={isSubmitting}
      onSaveFormTemplate={onSubmit}
      // to prevent user changes being overwritten when the save request succeeds and
      // overwrites the form template state with the server response
      isEditingDisabled={isSubmitting}
    />
  );
}
